import { CompanyEntity } from "../entity/CompanyEntity";
import { Company } from "../gateway/Company/Company";
import { NormalizeString } from "../utils/normalize-string/NormalizeString";

export class GetCompaniesByFilterUsecase {
    constructor() {
        this.CompanyGateway = new Company();
    }

    async execute({ accountingId, filter = {}, options = {} }) {
        if (!accountingId || !filter) return [];
        const input = {
            accountingId
        };
        let companies = await this.CompanyGateway.getByAccId(input);
        if (filter.status?.length) {
            companies = this.filterStatus(companies, filter.status);
        }
        if (filter.companyModel) {
            companies = this.filterCompanyModel(companies);
        }
        if (filter.fromAccounting) {
            companies = this.filterFromAccounting(companies);
        }
        if (filter.name) {
            companies = this.filterName(companies, filter.name);
        }
        if (filter.documents?.length) {
            companies = this.filterDocuments(companies, filter.documents);
        }
        if (filter.fortes) {
            companies = this.filterFortes(companies);
        }
        if (filter.omie) {
            companies = this.filterOmie(companies);
        }
        if (options?.entity) {
            return companies.map((company) => CompanyEntity.restore(company));
        }
        return companies;
    }

    filterStatus(companies, status) {
        return companies.filter((company) => status.includes(company.status));
    }

    // _id: { $ne: "EMPRESA_MODELO" },
    filterCompanyModel(companies) {
        return companies.filter((company) => company._id !== "EMPRESA_MODELO");
    }

    // "events.fromAccounting": { $exists: false }
    filterFromAccounting(companies) {
        return companies.filter(
            (company) => company.events?.fromAccounting === undefined
        );
    }

    filterName(companies, name) {
        return companies.filter((company) => {
            const companyName = NormalizeString.normalizeUpperCaseNd(
                company.name
            );
            return companyName.includes(
                NormalizeString.normalizeUpperCaseNd(name)
            );
        });
    }

    filterDocuments(companies, documents) {
        return companies.filter((company) =>
            documents.includes(company.document)
        );
    }

    filterFortes(companies) {
        return companies.filter(
            (company) => company.preferences?.plan === "Fortes"
        );
    }

    filterOmie(companies) {
        return companies.filter(
            (company) => !company.relation?.nibo || !company.relation?.contaazul
        );
    }
}
